import {Roles} from "@/enum/roles";

const ACLMixin = {
    computed: {
        isStorekeeper: function () {
            return this.$store.getters['oauth/hasScope'](Roles.STOREKEEPER);
        },
        isPacker: function () {
            return this.$store.getters['oauth/hasScope'](Roles.PACKER);
        },
        isChief: function () {
            return this.$store.getters['oauth/hasScope'](Roles.CHIEF);
        },
        isMaster: function () {
            return this.isStorekeeper && this.isPacker && this.isChief;
        }
    }
};

export {ACLMixin};
